// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuzM0afnaxofWsFCBo_J_fpRSTIGWFfSg",
  databaseURL: "https://magic-beacon-test-default-rtdb.firebaseio.com/",
};

// Initialize Firebase with a unique name "magicBeaconTestApp"
const app = initializeApp(firebaseConfig, "magicBeaconTestApp");
const database = getDatabase(app);

export { database };
